module.exports = __webpack_public_path__ + "static/media/play.9bd78894.png";